import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import {
  combinedSettingsSelector,
  getCompositeSettingSelector,
  type SettingsPropsParametricSelector,
  TargetSelector
} from "@client/selectors";
import { type AppState } from "@client/types";
import classnames from "classnames";
import { type Action, type Dispatch } from "redux";
import { setActiveTag } from "./actions";
import Component, { type PortfolioGalleryComponentActionProps, type PortfolioGalleryComponentMapProps } from "./component";
import {
  makeActiveTagIdSelector,
  makeActiveTagItemsIdsSelector,
  makeAllTagsSelector,
  makeClassNameSelector,
  makeItemPropsSelector
} from "./selectors";

const makeMapStateToProps = () => {
  const activeTagItemsIdsSelector = makeActiveTagItemsIdsSelector();
  const allTagsSelector = makeAllTagsSelector();
  const activeTagIdSelector = makeActiveTagIdSelector();
  const classNameSelector = makeClassNameSelector();
  const itemPropsSelector = makeItemPropsSelector() as SettingsPropsParametricSelector;
  const tagsSettingSelector = getCompositeSettingSelector(TargetSelector.Entity, "tags");
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, ["prtfSpace", "prtfColumns"]);

  return (state: AppState, props: RootContainerProps): PortfolioGalleryComponentMapProps => {
    const settings = settingsSelector(state, props);
    return {
      ...props,
      activeTag: activeTagIdSelector(state, props),
      className: classNameSelector(state, props),
      orientation: "vertical",
      gutter: settings.prtfSpace,
      columns: +settings.prtfColumns,
      itemProps: itemPropsSelector(state, props),
      items: activeTagItemsIdsSelector(state, props),
      showTags: !!tagsSettingSelector(state, props),
      tagsClassName: classnames(),
      tags: allTagsSelector(state, props)
    };
  };
};

const mapDispatchToProps = (
  dispatch: Dispatch<Action>,
  props: RootContainerProps
): PortfolioGalleryComponentActionProps => ({
  onTagClick: (tag: string) => dispatch(setActiveTag(props, tag))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
